import { render, staticRenderFns } from "./OrderBasicData.vue?vue&type=template&id=bda7d7a4&scoped=true&"
import script from "./OrderBasicData.vue?vue&type=script&lang=js&"
export * from "./OrderBasicData.vue?vue&type=script&lang=js&"
import style0 from "./OrderBasicData.vue?vue&type=style&index=0&id=bda7d7a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7d7a4",
  null
  
)

export default component.exports